<script setup lang="ts">
defineProps({
	rows: {
		type: String,
		default: '10',
	},
});

const { isTablet } = useWindowResize();
</script>
<template>
  <MultipleSkeletonLoader
    class="attendee-loader-container"
    :rows="rows"
    has-divider
  >
    <div class="attendee-loader-item">
      <template v-if="isTablet">
        <div class="attendee-loader-mobile-item">
          <div class="attendee-info-loader">
            <VSkeletonLoader
              type="avatar"
              width="40"
              height="40"
            />
            <SentencesSkeletonLoader width="130" />
          </div>
          <div class="btn-group-loader">
            <ButtonSkeletonLoader
              width="38"
              height="38"
            />
            <ButtonSkeletonLoader
              width="90"
              height="38"
            />
          </div>
        </div>
        <div class="attendee-detail-loader">
          <SentencesSkeletonLoader />
        </div>
      </template>
      <template v-else>
        <div class="attendee-info-loader">
          <VSkeletonLoader
            type="avatar"
            width="40"
            height="40"
          />
          <VSkeletonLoader
            class="attendee-paragraph"
            type="list-item-two-line"
          />
        </div>
        <VSkeletonLoader
          v-for="(count, cIndex) in 4"
          :key="count"
          type="list-item"
          :class="`attendee-line-${cIndex}`"
        />
        <ButtonSkeletonLoader
          v-for="count in 2"
          :key="count"
          class="action-btn"
          width="40"
        />
        <ButtonSkeletonLoader
          class="action-btn"
        />
      </template>
    </div>
  </MultipleSkeletonLoader>
</template>
<style scoped lang="scss">
.attendee-loader-container {
    @include media-query-max(tablet) {
      padding: spacings-get(4) 0;
    }

  .attendee-loader-item {
    display: grid;
    grid-template-columns: minmax(auto, 1fr) minmax(auto, 1fr) rem(100) rem(140) rem(100) rem(100) rem(100) rem(100);
    align-items: center;
    padding-bottom: spacings-get(4);

    @include media-query-max(tablet) {
      grid-template-columns: auto;
    }

    :deep(.v-skeleton-loader__list-item) {
      padding-right: spacings-get(6);
    }

    :deep(.attendee-line-3 > .v-skeleton-loader__list-item) {
      padding: spacings-get(6);
    }

    :deep(.v-skeleton-loader__avatar) {
      width: spacings-get(10);
      height: spacings-get(10);
      min-width: spacings-get(10);
      min-height: spacings-get(10);
      margin: 0;
    }

    .attendee-info-loader {
      display: grid;
      grid-template-columns: rem(40) 1fr;

      @include media-query-max(tablet) {
        gap: spacings-get(1);
      }

      :deep(.v-skeleton-loader__text:first-child) {
        margin-bottom: spacings-get(4);

        @include media-query-max(tablet) {
          margin: 0;
        }
      }

      .attendee-paragraph {
        width: 100%;
      }
    }

    .action-btn {
      margin: auto;
      width: 100%;
    }

    .attendee-loader-mobile-item {
      display: flex;
      justify-content: space-between;

      .btn-group-loader {
        display: grid;
        grid-template-columns: rem(38) rem(90);
        column-gap: spacings-get(2);
      }
    }

    .attendee-detail-loader {
      margin-top: spacings-get(2);
      padding: spacings-get(3);
      background-color: colors-get(gray, 50);
      @include border-radius-default;

      :deep(.v-skeleton-loader) {
        background-color: colors-get(gray, 50);
      }
    }
  }
}

</style>